import React from 'react';
import { IntegrationSettings } from '@anticatrade/shared';
import { WoocommerceSettings, hasRequiredWoocommerceSettings } from './Woocommerce';
import { MarketplaceSettings } from './Marketplace';

interface IntegrationSettingsFormProps {
	settings: IntegrationSettings;
	onChange: (settings: IntegrationSettings) => void;
}

interface IntegrationForm {
	// Form renders the integration-specific settings fields.
	Form: React.ComponentType<IntegrationSettingsFormProps>;
	// isComplete tells whether the required settings have been filled
	// in.
	isComplete: (settings: IntegrationSettings) => boolean;
}

// integrationForms maps an integration key to its settings form. An
// integration without an entry doesn't have settings.
const integrationForms: Record<string, IntegrationForm> = {
	woocommerce: {
		Form: WoocommerceSettings,
		isComplete: hasRequiredWoocommerceSettings,
	},
	proantic: {
		Form: MarketplaceSettings,
		isComplete: () => true,
	},
	anticoantico: {
		Form: MarketplaceSettings,
		isComplete: () => true,
	},
};

export type { IntegrationForm, IntegrationSettingsFormProps };
export { integrationForms };
